import RenderMenu from './render-menu'
import MenuWrapper from './menu-wrapper'

export default {
  name: 'VsMenu',
  functional: true,
  props: {
    items: {
      type: Array,
      default: null
    },
    border: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  render(h, { props, data, children }) {
    const classes = data.class || {}

    classes['no-border'] = !props.border
    classes['no-background'] = props.transparent

    if (props.items && props.items.length)
      return h(RenderMenu, { ...data, props: props, class: classes }, children)
    else
      return h(MenuWrapper, { data, class: classes }, children)
  }
}
